<template>
    <div>
        <Row>
        <i-col span="22">
        </i-col>
        <i-col span="2">
            <Button type="primary" @click="add">新增</Button>  
        </i-col>
    </Row>
        <Table :context="self" :data="tableData" :columns="tableColumns" stripe border></Table>
         <div style="margin: 10px;overflow: hidden">
                    <div style="float: right;">
                        <Page :total="total" :current="page" @on-change="changePage" :page-size="pagesize" show-total></Page>
                    </div>
        </div>

    </div>
</template>
<script>
import { hotel_privileges,hotel_deleteprivileges } from "../../api/privilegesapi";
export default {
  data() {
    return {
      self: this,
      tableData: [],
      total: 0,
      page: 1,
      pagesize: 10,
      formInline: {
        keywords: ""
      },
      tableColumns: [
        {
          title: "权限名称",
          key: "name",
          align: "center"
        },
        {
          title: "权限等级",
          key: "type",

          align: "center",
          render: (h, params) => {
            var issupper = params.row.type == 0 ? "页面级权限" : "按钮级权限";
            return h("span", issupper);
          }
        },

        {
          title: "权限描述",
          align: "center",

          key: "description"
        },
        {
          title: "控制器名",
          align: "center",

          key: "control"
        },
        {
          title: "方法名",
          align: "center",
          key: "action"
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.show(params.row);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ]
    };
  },
  methods: {
    mockTableData() {
      let para = {
        page: this.page,
        pagesize: this.pagesize
      };
      this.$Loading.start();
      hotel_privileges(para).then(res => {
        this.$Loading.finish();
        var Data = res.data;
        this.total = Data.data.total;
        this.tableData = Data.data.data;
      });
    },
    show(param) {
      this.$router.push({ path: "/hotelupdte", query: param });
    },
    add() {
      this.$router.push({ path: "/hoteladd" });
    },
    remove(index) {
      let self = this;
      this.$Modal.confirm({
        title: "权限列表",
        content: `是否删除此记录`,
        onOk: function() {
          this.$Loading.start();
          let para = { id: index };
          hotel_deleteprivileges(para).then(res => {
            let data = res.data;
            if (data.code == 1) {
              self.$Message.success(data.message);
              self.changePage(self.page);
            } else {
              self.$Message.error(data.message);
            }
          });
        }
      });
    },
    changePage(row) {
      this.page = row;
      this.mockTableData();
    }
  },
  mounted() {
    this.mockTableData();
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/privileges/hotelindex.vue